import type { ReactNode } from 'react';

import logoUrl from '../assets/mva-lab-logo-ngang.webp';

/** Tỉ lệ cao trên rộng của tệp logo — giữ đúng để logo không bị bóp méo. */
const LOGO_ASPECT_RATIO = 223 / 720;

/**
 * Logo chính thức của MVA Lab (bản ngang, có dòng "TECH FOR SOLUTION") — ở đầu thanh điều hướng,
 * trang đăng nhập và màn hình chờ.
 *
 * Tệp lấy từ bản gốc ở <c>docs/thuong-hieu/mva-lab-logo-ngang-goc.jpg</c>: chỉ cắt bớt khoảng trắng
 * thừa quanh logo, đưa nền về trắng tuyệt đối và thu nhỏ cho web. Hình dáng, màu và tỉ lệ giữ nguyên,
 * đúng quy định thương hiệu: không vẽ lại, không kéo giãn, không đổi màu, không bỏ dòng chữ phụ.
 *
 * Logo có nền trắng, nên chỉ đặt trên nền trắng. Trên nền màu thì đặt trong một ô trắng (xem khung
 * giới thiệu ở trang đăng nhập) — không đảo màu logo cho hợp nền.
 */
export function BrandMark({ width = 192 }: { readonly width?: number }): ReactNode {
  return (
    <img
      src={logoUrl}
      alt="MVA Lab"
      width={width}
      height={Math.round(width * LOGO_ASPECT_RATIO)}
      className="erp-brand-mark"
      draggable={false}
    />
  );
}
